import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MaterialModule } from '../shared/material.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AsyncPipe, CommonModule } from '@angular/common';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthInterceptor } from '../shared/auth-interceptor';
import { SharedModule } from '../shared/shared.module';
import { RouteReuseStrategy } from '@angular/router';
import { PrimengModule } from '../shared/primeng-module';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { ApplicationModule } from './application/application.module';
import { MatToolbarModule } from '@angular/material/toolbar'; 
import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import { CustomOwlDateTimeIntl } from 'shared/model/custom-owl-datetime-model';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeAr from '@angular/common/locales/ar';

// Register all possible locales you may switch to
registerLocaleData(localeTr, 'tr');
registerLocaleData(localeTr, 'tr-TR');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEn, 'en-US');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeAr, 'ar-SA');
registerLocaleData(localeAr, 'ky');
registerLocaleData(localeAr, 'ky-KZ');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');


export function getLocale() {
  const langKey = localStorage.getItem('langKey') || 'tr-TR';

  if (langKey.startsWith('tr')) return 'tr';
  if (langKey.startsWith('en')) return 'en';
  if (langKey.startsWith('de')) return 'de';
  if (langKey.startsWith('ky')) return 'ky';
  if (langKey.startsWith('ar')) return 'ar';

  return 'tr'; // fallback
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    PrimengModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    ApplicationModule,
    SharedModule.forRoot(),
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' })
  ],
  providers: [
    provideAnimationsAsync(),
    AsyncPipe,
    JwtHelperService,
    {
      provide: API_BASE_URL,
      useValue: environment.apiUrl
    },
    {
      provide: LOCALE_ID,
      useFactory: getLocale
    },
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: OwlDateTimeIntl,
      useClass: CustomOwlDateTimeIntl
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
